"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupLevelSidebarPresenterImpl = void 0;
class GroupLevelSidebarPresenterImpl {
    viewModel;
    constructor(viewModel) {
        this.viewModel = viewModel;
        this.viewModel.isSidebarOpen = sessionStorage.getItem("sidebar") !== "closed";
    }
    openSidebar() {
        this.viewModel.isSidebarOpen = true;
    }
    closeSidebar() {
        this.viewModel.isSidebarOpen = false;
    }
    handlePageSizeChange(pageSize) {
        this.viewModel.pagesize = pageSize;
    }
}
exports.GroupLevelSidebarPresenterImpl = GroupLevelSidebarPresenterImpl;
